export const NAME = 'myprofile';

export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
export const SUCCESS_UPDATE_PROFILE = 'SUCCESS_UPDATE_PROFILE';
export const FAILURE_UPDATE_PROFILE = 'FAILURE_UPDATE_PROFILE';

export const RESET_FORM_SUBMIT_UPDATE_PROFILE = 'RESET_FORM_SUBMIT_UPDATE_PROFILE';

export const REQUEST_USER_INFO = 'REQUEST_USER_INFO';
export const SUCCESS_USER_INFO = 'SUCCESS_USER_INFO';
export const FAILURE_USER_INFO = 'FAILURE_USER_INFO';



// WEBPACK FOOTER //
// ./src/services/account/myprofile/constants.js